<div class="container-fluid">
    <div class="row">
        <div class="col-12 five">
           <!-- <h1>My shop products</h1>-->
        </div>
    </div>
    <div class="container-fluid">
       <div class="row">
  <!-- Shop Name -->
  <div class="col-md-3 mt-3">
    <div class="form-floating">
      <select class="form-select form-control-sm" id="shopName"
              (change)="selectAllProduct($event)" [(ngModel)]="selectedShopId">
        <option value="" disabled selected>Select Shop Name</option>
        <option *ngFor="let shop of shopList" [value]="shop.traderId">{{ shop.traderName }}</option>
      </select>
      <label>Select Shop Name</label>
    </div>
  </div>

  <!-- Category Name -->
  <div class="col-md-3 mt-3">
    <div class="form-floating position-relative">
      <select class="form-select form-control-sm" [disabled]="!isCategoryEnabled"
              (change)="selectCatList($event)" [(ngModel)]="selectedCateGoryName">
        <option value="" disabled selected>Select Category Name</option>
        <option *ngFor="let cat of categoryNameList" [value]="cat">{{ cat }}</option>
      </select>
      <label>Select Category</label>
    </div>
  </div>

  <!-- Subcategory Name -->
  <div class="col-md-3 mt-3">
    <div class="form-floating position-relative">
      <select class="form-select form-control-sm" [disabled]="!isSubCategoryEnabled"
              (change)="selectSubCatList($event)" [(ngModel)]="selectSubCateGoryName">
        <option value="" disabled selected>Select Sub Category Name</option>
        <option *ngFor="let sub of subCategoryNameList" [value]="sub">{{ sub }}</option>
      </select>
      <label>Select Sub Category</label>
    </div>
  </div>

  <!-- Clear Filters Button -->
  <div class="col-md-3 mt-3 d-flex align-items-end">
    <button class="btn btn-danger w-100" (click)="clearFilters()" [disabled]="!selectedCateGoryName && !selectSubCateGoryName">
      <i class="fas fa-trash me-2"></i> Clear Filters
    </button>
  </div>
</div>

        <div class="container-fluid p-2 mt-3">
            <div class="card container-fluid bg-white mt-3 col-md-12">
                <div class="row mt-2 mb-2">
                    <div class="col-lg-9">
                        <p class="text-danger"><span class="text-bold">Note* :</span> If the MRP or SRP price is set to 0, the product status will be inactive and it will not be displayed in the Mykadai app</p>
                    </div>
                    <div class="col-lg-3 col-12 float-right">
                        <div class="form-floating">
                            <input type="search" class="form-control" placeholder="search"
                                   [(ngModel)]="searchText">
                            <label class="text-gray">Search</label>
                        </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row mt-3">
                    <div class="col-md-12 table-responsive table-wrapper-scroll-y tableFixHead">
                        <table class="table text-center">
                            <thead class="header sticky-top border-0">
                            <tr>
                                <th>S.No</th>
                                <th>Product Name</th>
                                <th>Category</th>
                                <th>Sub Category</th>
                                <th>MRP Price</th>
                                <th>SRP Price</th>
                                <th></th>
                                <th></th>
                                <th>Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let Product of activeShopProducts | filter: searchText; let i = index;">
                                <td>{{i + 1}}</td>
                                <td>{{Product.productName}}</td>
                                <td>{{Product.catName}}</td>
                                <td>{{Product.subCatName}}</td>
                                <td><input type="text" style="text-align: right" class="form-control"
                                                         value="{{Product.shopProductMRP}}"
                                                         [(ngModel)]="Product.shopProductMRP"
                                                         (input)="updateButtonShow(Product)"></td>
                                <td><input type="text" style="text-align: right" class="form-control"
                                                         value="{{Product.shopProductSRP}}"
                                                         [(ngModel)]="Product.shopProductSRP"
                                                         (input)="updateButtonShow(Product)"></td>
                                <td>
                                    <button type="button" class="btn btn-update" [disabled]="!Product.isUpdateEnabled"
                                            (click)="updateSRP(Product.shopProductSRP, Product.shopProductMRP, Product.shopProductId)">
                                        Update
                                    </button>
                                </td>
                                <td>
                                    <i class="fas fa-edit fa-lg mr-2 mt-2" (click)="editProduct(Product)" type="button"></i>
                                </td>
                                <td>
                                    <div class="form-check form-switch">
                                        <input
                                                class="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                [checked]="Product.status === 'Active'"
                                                (change)="updateStatus(Product.shopProductId, $event.target.checked ? 'Active' : 'InActive')"
                                                id="flexSwitchCheck{{i}}"
                                        />
                                        <label class="form-check-label" [for]="'flexSwitchCheck' + i"></label>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>
